import { baseApi } from "./baseApi";

export interface AdminChatParticipant {
  _id?: string;
  firstName?: string;
  lastName?: string;
  image_url?: string;
}

export interface AdminChatDocument {
  _id: string;
  customer_id?: AdminChatParticipant | string;
  driver_id?: AdminChatParticipant | string;
  booking_id?: { number?: string };
}

export interface AdminChatMessage {
  _id: string;
  chat_id: string;
  sender_id: {
    _id: string;
    firstName?: string;
    lastName?: string;
    image_url?: string;
  } | null;
  message_type: string;
  content: string | Record<string, unknown>;
  createdAt?: string;
}

type ApiEnvelope<T> = {
  statusCode: number;
  message: string;
  data: T;
};

export const chatAdminApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAdminChatByBooking: builder.query<
      ApiEnvelope<AdminChatDocument>,
      string
    >({
      query: (bookingId) => ({
        url: `/chat/admin/booking/${bookingId}`,
        method: "GET",
      }),
      providesTags: (_result, _error, bookingId) => [
        { type: "BookingChat", id: bookingId },
      ],
    }),
    getAdminChatMessages: builder.query<
      ApiEnvelope<{
        results: AdminChatMessage[];
        pagination: {
          total: number;
          page: number;
          limit: number;
          totalPages: number;
        };
      }>,
      { chatId: string; page?: number; limit?: number; direction?: "asc" | "desc" }
    >({
      query: ({ chatId, page = 1, limit = 200, direction = "asc" }) => ({
        url: `/chat/admin/chats/${chatId}/messages`,
        method: "GET",
        params: { page, limit, direction },
      }),
      providesTags: (_result, _error, { chatId }) => [
        { type: "BookingChatMessages", id: chatId },
      ],
    }),
  }),
});

export const {
  useGetAdminChatByBookingQuery,
  useGetAdminChatMessagesQuery,
} = chatAdminApi;
